module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('s-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.$route.path == '/') ? _c('swiper-drawer') : _vm._e(), _vm._v(" "), (_vm.conFooter) ? _c('content-footer') : _vm._e(), _vm._v(" "), (_vm.showFooter) ? _c('s-footer') : _vm._e(), _vm._v(" "), (_vm.showLogin) ? _c('login', {
    on: {
      "loggedIn": _vm.getUserAccount
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRegister) ? _c('register') : _vm._e(), _vm._v(" "), _c('msg-modal'), _vm._v(" "), (_vm.showLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (_vm.showUserAgree) ? _c('user-agree') : _vm._e(), _vm._v(" "), (_vm.showAboutTruthso) ? _c('about-truthso') : _vm._e(), _vm._v(" "), (_vm.showSBg) ? _c('img', {
    staticClass: "bg_img",
    attrs: {
      "src": require("./assets/hp_background.png")
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35cdacf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 757
// module chunks = 1